import $store from "../store";
import store from "../store";
import Vue from "vue";
import i18n from "../lang/i18n";
// import { AuthService } from '@/services/auth.service'

/**
 * Current user state initialization
 * @WARN Must be always first in middleware chain
 */
export async function initCurrentUserStateMiddleware(to, from, next) {
  next();

  // const haveAccess = $store.state.auth.haveAccess
  // if (AuthService.hasRefreshToken() && !haveAccess) {
  //   try {
  //     await AuthService.debounceRefreshTokens()
  //     await $store.dispatch('user/getCurrent')
  //     next()
  //   } catch (e) {
  //     console.log(e)
  //   }
  // } else {
  //   next()
  // }
}

/**
 * Check access permission to auth router
 */
export function checkAccessMiddleware(to, from, next) {
  const haveAccess = $store.state.auth.haveAccess || false;
  const isAuthRoute = to.matched.some(item => item.meta.requireAuth);

  if (
    isAuthRoute &&
    haveAccess &&
    to.meta.requireRoles !== undefined &&
    to.meta.requireRoles.length > 0
  ) {
    let validRole = false;
    let roleNames = store.state.auth.roles.map(role => role.name);
    to.meta.requireRoles.forEach(requireRole => {
      if (roleNames.includes(requireRole)) {
        validRole = true;
      }
    });

    if (!validRole) {
      Vue.notify({
        title: "Important message",
        text: "Bạn không có quyền sử dụng chức năng này",
        type: "error"
      });
      return next({ name: "ProfileUser" });
    }
  }
  if (isAuthRoute && haveAccess) return next();
  if (isAuthRoute) return next({ path: "/login" });
  next();
}

export function setPageTitleMiddleware(to, from, next) {
  const pageTitle = to.matched.find(item => item.meta.title);

  if (pageTitle) {
    window.document.title =
      pageTitle.meta.title + " - " + i18n.t("common.project_name");
  } else {
    window.document.title = "" + i18n.t("common.project_name");
  }
  next();
}
